import Vue from 'vue'

const bus = new Vue()

function deferred() {
    let resolve, reject
    const promise = new Promise((res, rej) => { resolve = res; reject = rej })
    return { promise, resolve, reject }
}

const state = Vue.observable({
    active: null,        // { id, component, props, input, options, dfd }
    queue: [],
    closeIntent: null    // { type: 'resolve'|'reject', payload }
})

let uid = 0

function emitChange() {
    bus.$emit('change', { active: state.active, queue: state.queue })
}

function ensureNext() {
    if (state.active) return
    if (!state.queue.length) return

    state.active = state.queue.shift()
    state.closeIntent = null
    emitChange()

    bus.$emit('need-show', state.active)
}

function open(component, { props = {}, input = null, options = {} } = {}) {
    const dfd = deferred()
    const item = { id: ++uid, component, props, input, options, dfd }

    state.queue.push(item)
    emitChange()
    ensureNext()

    return dfd.promise
}

// user bấm OK -> host hide; resolve sau hidden.bs.modal
function requestResolve(payload) {
    if (!state.active) return
    state.closeIntent = { type: 'resolve', payload }
    bus.$emit('need-hide', state.closeIntent)
}

// user bấm Cancel/Close -> host hide; reject sau hidden.bs.modal
function requestReject(payload) {
    if (!state.active) return
    state.closeIntent = { type: 'reject', payload }
    bus.$emit('need-hide', state.closeIntent)
}

// host gọi khi modal đã hidden hoàn toàn
function finalizeAfterHidden(dismissReason = 'dismiss') {
    const active = state.active
    const intent = state.closeIntent

    if (active?.dfd) {
        if (intent?.type === 'resolve') active.dfd.resolve(intent.payload)
        else if (intent?.type === 'reject') active.dfd.reject(intent.payload)
        else active.dfd.reject(dismissReason) // ESC/backdrop
    }

    state.active = null
    state.closeIntent = null
    emitChange()
    ensureNext()
}

function clear(reason = 'cleared') {
    if (state.active?.dfd) state.active.dfd.reject(reason)
    state.queue.forEach(i => i.dfd?.reject?.(reason))
    state.active = null
    state.queue = []
    state.closeIntent = null
    emitChange()
}

function on(event, cb) { bus.$on(event, cb); return () => bus.$off(event, cb) }

export default {
    state,
    open,
    requestResolve,
    requestReject,
    finalizeAfterHidden,
    clear,
    on
}